import React from 'react'
import { IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { IconTrash } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

interface Iprops {
  emails: string[]
  email: string
  setEmails: (value: string[]) => void

  defaultPreviewEmail?: string
  setDefaultPreviewEmail: (value: string) => void

  defaultEmail?: string
  setDefaultEmail: (value: string) => void
}

const EditEmailRow: React.FC<Iprops> = ({
  email,
  emails,
  setEmails,
  setDefaultEmail,
  setDefaultPreviewEmail,
  defaultEmail,
  defaultPreviewEmail,
}) => {
  const theme = useTheme()

  const isPreviewMail = email === defaultPreviewEmail
  const isDefaultMail = email === defaultEmail

  const removeItem = () => {
    const newEmails = emails.filter((i: string) => i !== email)
    setEmails(newEmails)
  }

  const handleDefaultMail = () => {
    if (defaultEmail !== email) {
      setDefaultEmail(email)
    } else {
      setDefaultEmail('')
    }
  }

  const handleDefaultPreviewMail = () => {
    if (defaultPreviewEmail !== email) {
      setDefaultPreviewEmail(email)
    } else {
      setDefaultPreviewEmail('')
    }
  }

  return (
    <div className="EditEmailRow">
      <div className="row">
        <div className="email">{email}</div>
        <div className="options">
          <div className="preview rightBorder" onClick={handleDefaultPreviewMail}>
            <Typography
              sx={isPreviewMail ? { backgroundColor: theme.palette.info.dark } : {}}
              color={isPreviewMail ? 'white' : theme.palette.error.light}
              className="setItem"
            >
              <FormattedMessage id="set-as-preview" />
            </Typography>
          </div>
          <div className="default rightBorder" onClick={handleDefaultMail}>
            <Typography
              sx={isDefaultMail ? { backgroundColor: theme.palette.info.dark } : {}}
              // color={{ color: isDefaultMail ? 'white' : theme.palette.info.dark }}
              color={isDefaultMail ? 'white' : theme.palette.text.primary}
              className="setItem"
            >
              <FormattedMessage id="set-as-default" />
            </Typography>
          </div>
          <Tooltip className="remove" title="Remove" onClick={removeItem}>
            <IconButton>
              <IconTrash stroke="none" color={theme.palette.error.dark} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default EditEmailRow
